import { fromNullable } from 'fp-ts/lib/Option';
import { asks } from 'fp-ts/lib/Reader';
import * as qs from 'qs';
import { toRemoteData } from '../../utils/axios';
import { mapRD } from '../../utils/object.utils';
export var trello = asks(function (ctx) {
    var _a = ctx.domContext, getHash = _a.getHash, getOrigin = _a.getOrigin;
    return fromNullable(ctx.trelloOptions).map(function (_a) {
        var clientKey = _a.clientKey;
        var connectTrello = function () {
            var query = {
                callback_method: 'fragment',
                return_url: getOrigin() + "/export/trello",
                scope: 'read,write',
                expiration: 'never',
                name: 'Volley',
                key: clientKey,
                responseType: 'fragment',
            };
            return {
                method: 'redirect',
                url: 'https://trello.com/1/authorize?' + qs.stringify(query),
            };
        };
        var completeConnectTrello = function () {
            return new Promise(function (resolve, reject) {
                var hash = getHash();
                var parsed = qs.parse(hash);
                if (typeof parsed === 'object' &&
                    !!parsed &&
                    typeof parsed.token === 'string' &&
                    parsed.token.length > 0) {
                    resolve({
                        token: parsed.token,
                        api_key: clientKey,
                    });
                }
                else {
                    reject(new Error('No token in the hash'));
                }
            });
        };
        var getBoards = function (projectId, integrationId) {
            return toRemoteData(ctx.axios.get("/api/products/" + projectId + "/integrations/" + integrationId + "/trello-boards")).pipe(mapRD(function (boards) {
                return boards.map(function (board) { return ({
                    id: board.board_id,
                    organizationId: board.organization_id,
                    name: board.board_name,
                    group: board.organization_name || 'Personal Boards',
                    lists: board.lists.map(function (_a) {
                        var id = _a.id, name = _a.name;
                        return ({ id: id, name: name });
                    }),
                }); });
            }));
        };
        return {
            connect: connectTrello,
            completeConnect: completeConnectTrello,
            getBoards: getBoards,
        };
    });
});
//# sourceMappingURL=trello.service.js.map